export const environment = {
   production: false,
  apiBaseUrl: 'https://pinkyauradevapi.ape-org.com/api',
  imageBaseUrl: 'https://pinkyauradevapi.ape-org.com'  
   /*  production: false,
  apiBaseUrl: 'https://localhost:7256/api',
  imageBaseUrl: 'https://localhost:7256' */  
};
